import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ServiceViewer from './ServiceViewer';

const services = [
    {
        id: 1,
        kind: 'glazing',
        image: '/services/glazing.jpg',
        title: 'Glazing',
        tagline: 'Light, strength and style',
        items: ['Unitised Glazing', 'Semi Unitised Glazing', 'Toggle Glazing', 'Spider Glazing', 'Curtain Wall', 'Tension Cable / Rod Glazing'],
    },
    {
        id: 2,
        kind: 'cladding',
        image: '/services/cladding.jpg',
        title: 'Cladding',
        tagline: 'Durable architectural skins',
        items: ['Aluminium Cladding Panels', 'High-Pressure Laminate', 'Terracotta Tiles', 'Zinc', 'Porcelain Tiles', 'Solid Aluminium'],
    },
    {
        id: 3,
        kind: 'doors',
        image: '/services/doors.jpg',
        title: 'Doors & Windows',
        tagline: 'Durable elegance',
        items: ['Sliding Windows with inbuilt railing', 'Slimline Windows', 'Casement Windows', 'Ventilators', 'Lift and Slide', 'Fixed Doors and Windows', 'Patch Fixed', 'Auto Sliding Door'],
    },
    {
        id: 4,
        kind: 'cleanroom',
        image: '/services/cleanroom.jpg',
        title: 'Clean Room Systems',
        tagline: 'Controlled, precise interiors',
        items: ['Flush Door / Window', 'Walkable & Non Walkable Ceiling', 'Clean Room Partitions', 'Walk on Ceilings', 'OT Room Solutions', 'Fire Rated / Emergency Exit Doors'],
    },
    {
        id: 5,
        kind: 'railing',
        image: '/services/railing.jpg',
        title: 'Railing',
        tagline: 'Safety meets finish',
        items: ['SS Railing', 'MS Railing', 'Free Standing Railing'],
    },
    {
        id: 6,
        kind: 'canopy',
        image: '/services/canopy.jpg',
        title: 'Canopies & Skylights',
        tagline: 'Welcoming light and cover',
        items: ['Spider Canopies', 'Curtain Wall Canopies', 'Aluminium Framed Skylights', 'Spider Fitted Skylights'],
    },
];

const imageUrl = (path) => `${process.env.PUBLIC_URL}${path}`;

const Services = ({ limit }) => {
    const visibleServices = limit ? services.slice(0, limit) : services;
    const [active, setActive] = useState(null);

    return (
        <section className="page-section services-section" id="services">
            <div className="container">
                <div className="section-intro reveal">
                    <p className="eyebrow">What we do</p>
                    <h2 className="section-title">Our services</h2>
                    <p>
                        Structural glazing, ACP cladding, aluminium doors and windows, railing, clean rooms, canopies, and skylights — fabricated and installed to a high standard.
                    </p>
                </div>
                <div className="row g-4">
                    {visibleServices.map((service, index) => (
                        <div className="col-md-6 col-lg-4" key={service.id}>
                            <article
                                className="svc-card reveal is-viewable"
                                style={{ transitionDelay: `${(index % 3) * 80}ms` }}
                                role="button"
                                tabIndex={0}
                                aria-label={`View ${service.title}`}
                                onClick={() => setActive(service)}
                                onKeyDown={(event) => {
                                    if (event.key === 'Enter' || event.key === ' ') {
                                        event.preventDefault();
                                        setActive(service);
                                    }
                                }}
                            >
                                <div className="svc-card-photo">
                                    <img src={imageUrl(service.image)} alt="" />
                                    <div>
                                        <h3>{service.title}</h3>
                                        <p>{service.tagline}</p>
                                    </div>
                                </div>
                                <ul>
                                    {service.items.map((item) => (
                                        <li key={item}>{item}</li>
                                    ))}
                                </ul>
                            </article>
                        </div>
                    ))}
                </div>
                {active && (
                    <ServiceViewer
                        image={imageUrl(active.image)}
                        title={active.title}
                        tagline={active.tagline}
                        onClose={() => setActive(null)}
                    />
                )}
                {limit && (
                    <div className="text-center mt-4">
                        <Link className="btn-line is-light" to="/services">All services</Link>
                    </div>
                )}
            </div>
        </section>
    );
};

export default Services;
